import { render, staticRenderFns } from "./Membership.vue?vue&type=template&id=20fce3d2&scoped=true"
import script from "./Membership.vue?vue&type=script&lang=js"
export * from "./Membership.vue?vue&type=script&lang=js"
import style0 from "@/assets/membership/style.css?vue&type=style&index=0&id=20fce3d2&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fce3d2",
  null
  
)

export default component.exports